<template>
  <div>
    <div class="about-us-header">
      <svg-icon icon-class="mine_aboutUs"></svg-icon>
      <div class="us-introduce">软件开发；技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；信息技术咨询服务；信息系统集成服务；软件销售；数据处理和存储支持服务；大数据服务；数据处理服务；储能技术服务；信息咨询服务（不含许可类信息咨询服务）；物联网技术研发；数字技术服务；市场营销策划；市场调查（不含涉外调查）；社会经济咨询服务；企业管理咨询；国内贸易代理；科技中介服务；物业管理；房地产经纪；非居住房地产租赁；互联网销售（除销售需要许可的商品）。</div>
    </div>
    <div class="about-us-cell">
      <div class="us-cell">
        <div class="us-cell-label">公司</div>
        <div class="us-cell-value">深圳致复科技有限公司</div>
      </div>
      <div class="us-cell us-cell-adress">
        <div class="us-cell-label">具体位置</div>
        <div class="us-cell-value">	深圳市福田区莲花街道福中社区福中一路1001号生命保险大厦二十层2007室</div>
        <svg-icon icon-class="mine-us-map"></svg-icon>
      </div>
      <div class="us-cell us-cell-phone">
        <div class="us-cell-label">联系电话</div>
        <div class="us-cell-value">
          <a :href="'tel:' + phone">021-51105660【点击拨打】</a>
        </div>
        <svg-icon icon-class="mine-us-phone"></svg-icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      phone: '021-51105660'
    }
  },
  
}
</script>

<style lang="less" scoped>
.about-us-header {
  width: 375px;
  height: 254.5px;
  background: #fff;
  .svg-icon {
    width: 59.5px;
    height: 66px;
    margin: 23.5px 0 0 158px;
  }
  .us-introduce {
    margin: 28.5px 20px 20px;
    font-size: 13px;
    font-weight: Regular;
    font-family: PingFang SC;
    color: #333333;
  }
}
.about-us-cell {
  width: 375px;
  height: 181px;
  margin-top: 15px;
  background: #fff;
  .us-cell {
    width: 356px;
    height: 54.96px;
    margin: auto;
    display: flex;
    align-items: center;
    font-family: PingFang SC;
    border-bottom: 0.5px solid #ededed;
    .us-cell-label {
      width: 83px;
      padding-left: 10.25px;
      font-size: 14px;
      font-weight: bold;
      color: #333333;
    }
    .us-cell-value {
      width: 230px;
      font-size: 12px;
      font-weight: Regular;
      color: #999999;
      a {
        color: #999999;
      }
    }
  }
  .us-cell-adress {
    height: 59.08px;
    .svg-icon {
      width: 25px;
      height: 25px;
      margin-left: 10.25px;
    }
  }
  .us-cell-phone {
    height: 66.96px;
    .svg-icon {
      width: 4.71px;
      height: 7.42px;
      margin-left: 17.25px;
    }
  }
}
</style>